export default "__VITE_ASSET__BgEXTU4A__"